var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 97.18 137.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3a5ea7;}.cls-2{fill:none;stroke:#3b5fa8;stroke-linecap:round;stroke-linejoin:round;stroke-width:5.41px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "teperdiste") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83,31.16a11.51,11.51,0,0,1-.47-2,14.21,14.21,0,0,1-.21-2.42,7.58,7.58,0,0,1,.75-3.4A14,14,0,0,1,85,20.52,27.69,27.69,0,0,1,87.39,18c.88-.82,1.69-1.64,2.44-2.47a14.61,14.61,0,0,0,1.86-2.62,6.17,6.17,0,0,0,.75-3,5.54,5.54,0,0,0-.54-2.5,5.26,5.26,0,0,0-1.48-1.82,6.7,6.7,0,0,0-2.18-1.11,9.32,9.32,0,0,0-2.62-.36A11.39,11.39,0,0,0,77,8V2.82A17.33,17.33,0,0,1,86.33,0a14.65,14.65,0,0,1,4.2.59A10.17,10.17,0,0,1,94,2.34a8.12,8.12,0,0,1,2.33,2.89,9,9,0,0,1,.86,4,9.4,9.4,0,0,1-.77,3.88,14.06,14.06,0,0,1-1.92,3.13A25.39,25.39,0,0,1,92,18.93c-.9.82-1.74,1.64-2.51,2.46a13.64,13.64,0,0,0-1.93,2.54,5.7,5.7,0,0,0-.76,2.91,8.87,8.87,0,0,0,.32,2.45,17.2,17.2,0,0,0,.65,1.87Zm2.64,12.23a3.28,3.28,0,0,1-2.29-.94,3.07,3.07,0,0,1-1-2.3,3,3,0,0,1,1-2.29,3.2,3.2,0,0,1,4.59,0,3,3,0,0,1,1,2.29,3.1,3.1,0,0,1-1,2.3A3.29,3.29,0,0,1,85.65,43.39Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.7,
    y: 125.01,
    width: 12.72,
    height: 9.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 75.65,
    y: 125.01,
    width: 12.72,
    height: 9.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.7,
    y: 52.73,
    width: 12.72,
    height: 72.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 15.43,
    y: 52.74,
    width: 60.22,
    height: 81.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 75.65,
    y: 52.74,
    width: 12.72,
    height: 81.94
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "44.45 15.73 50.77 37.14 44.45 37.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "32.6 52.74 32.6 15.73 58.24 15.73 58.24 52.7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.03b471b9f28aaec639f5181c03988f7b.svg";
export { ForwardRef as ReactComponent };